export default {
	seo_meta_title_leaguepass: 'NBA | Vidéos et temps forts de la NBA',
	seo_meta_desc_leaguepass: 'NBA Video présente des vidéos et les temps forts de la NBA',
	seo_meta_keywords_leaguepass: 'vidéos NBA, temps forts NBA, vidéos basket-ball, principaux matches, dunks, dossiers',
	seo_meta_title_featured: 'NBA | À la une',
	seo_meta_desc_featured: '',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA | NBA TV EN DIRECT',
	seo_meta_desc_nbatv: 'NBA TV Live est votre service live streaming 24h/24 de la chaîne NBA TV avec des matches NBA en direct et d\'archives toutes leurs semaines, programmation studio et couverture par des analystes',
	seo_meta_keywords_nbatv: 'chaîne NBA TV, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, émissions studio, the jump',
	seo_meta_title_classicgames: 'NBA | Matchs classiques',
	seo_meta_desc_classicgames: '',
	seo_meta_keywords_classicgames: '',
	seo_meta_title_videolist: 'NBA | Liste des vidéos',
	seo_meta_desc_videolist: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'NBA | Émissions NBA TV',
	seo_meta_desc_shows: '',
	seo_meta_keywords_shows: '',
	seo_meta_title_home: 'NBA à domicile',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'NBA | Chaînes',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'NBA | Chaîne',
	seo_meta_pre_title_categories: 'NBA | Catégories',
	seo_meta_title_categories: 'NBA | {0}',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'NBA | Catégorie',
	seo_meta_title_category: 'NBA | {0}',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'NBA | Vidéo',
	seo_meta_pre_title_event: 'NBA | Événement',
	seo_meta_title_events: 'NBA | Événement',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'NBA | Événements : {0}',
	seo_meta_desc_event: '',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'NBA | Recherche',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'NBA | Page non trouvée',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'Match NBA :',
	seo_meta_title_game: 'NBA | {0}',
	seo_meta_desc_game: '',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'NBA | Vidéos et temps forts de la NBA',
	seo_meta_desc_video: 'NBA Video présente des vidéos et les temps forts de la NBA',
	seo_meta_keywords_video: 'vidéos NBA, temps forts NBA, vidéos basket-ball, principaux matches, dunks, dossiers',
	seo_meta_title_channel: 'NBA | NBA TV EN DIRECT',
	seo_meta_desc_channel: 'NBA TV Live est votre service live streaming 24h/24 de la chaîne NBA TV avec des matches NBA en direct et d\'archives toutes leurs semaines, programmation studio et couverture par des analystes',
	seo_meta_keywords_channel: 'chaîne NBA TV, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, émissions studio, the jump',
	seo_meta_title_tvguide: 'NBA | Programme NBA TV',
	seo_meta_desc_tvguide: 'NBA TV Live est votre service live streaming 24h/24 de la chaîne NBA TV avec des matches NBA en direct et d\'archives toutes leurs semaines, programmation studio et couverture par des analystes',
	seo_meta_keywords_tvguide: 'chaîne NBA TV, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, émissions studio, the jump',
	timezone: 'ET',
	default_feed_error_message: 'Une erreur s\'est produite, le contenu n\'est pas disponible pour le moment. Merci de réessayer.',
	watch_in_app: 'REGARDER SUR L\'APPLICATION NBA',
	no_content: 'Pas de contenu',
	see_more: 'Voir plus',
	now_playing: 'LECTURE EN COURS',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: 'Vous avez atteint le nombre maximal de vidéos préférées. Supprimez-en certaines avant d\'en ajouter d\'autres.',
	item_live: 'En direct :',
	add_favourite_title: 'AJOUTER AUX FAVORIS',
	remove_favourite_title: 'SUPPRIMER DES FAVORIS',
	p_channel_live: 'En direct :',
	p_channel_schedule_title: 'Calendrier NBA TV',
	p_channel_schedule_watch: 'Regarder',
	p_channel_schedule_no_date: 'Aucune date actuellement disponible dans le calendrier.',
	p_channel_live24x7_title: 'NBA TV 24 h/24, 7 j/7',
	p_channel_live24x7_see_full_schedule: 'Voir le programme complet',
	p_channel_live24x7_up_next: 'Prochaine diffusion',
	p_channel_live24x7_on_demand: 'NBA TV : à la demande',
	p_channel_live24x7_collection: 'Collection',
	p_channel_live24x7_demand_1_logo_text: 'émissions originales',
	p_channel_live24x7_demand_1_show_name: 'Émissions NBA TV',
	p_channel_live24x7_demand_1_show_desc: 'Émissions NBA TV originales, avec notamment Shaqtin\' a Fool, Beyond the Paint, Game Time et Basketball Stories',
	p_channel_live24x7_demand_2_logo_text: 'Classic Games',
	p_channel_live24x7_demand_2_show_name: 'NBA | Matchs classiques',
	p_channel_live24x7_demand_2_show_desc: 'Regardez des matchs classiques en entier, avec notamment tous les matchs des Finales depuis 2000, des moments qui ont marqué l\'histoire de la ligue et des joueurs légendaires',
	p_channel_clips_title: 'Clips NBA TV',
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'Calendrier',
	p_nba_tv_shows: 'Émissions NBA TV',
	p_nba_tv_no_access_title: 'NBA 24 h/24, 7 j/7 : restez informé grâce aux analyses de match, aux analyses studio, aux programmes originaux et plus encore !',
	p_nba_tv_no_access_desc: 'Regardez des matchs en direct, ainsi que des émissions et des matchs classiques à la demande.',
	p_nba_tv_no_access_note: 'Des restrictions de diffusion peuvent s\'appliquer',
	tv_show_item_latest_episode: 'dernier épisode',
	tv_show_item_no_latest_episode: 'pas de dernier épisode',
	see_all: 'Voir tout',
	header_menu_watch: 'Regarder',
	header_menu_featured: 'À LA UNE',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',
	players: 'Joueurs',
	videos: 'Vidéos',
	teams: 'Équipes',
	most_searched: 'LES PLUS RECHERCHÉS',
	no_result: 'Pas de données',
	search_filter_type_most_relevant: 'Le plus pertinent',
	search_filter_type_most_viewed: 'Le plus regardé',
	search_filter_type_most_recent: 'Le plus récent',
	search_filter_type_last_30_days: 'Les 30 derniers jours',
	search_filter_type_last_6_months: 'Les 6 derniers mois',
	search_result_label: 'Résultats de recherche pour \'{keyword}\'',
	search_result_info: 'Afficher tous les résultats pour {keyword}',
	search_placeholder: 'Rechercher dans la vidéothèque',
	load_more: 'Charger plus...',
	button_subscribe: 'S\'abonner',
	button_sign_in: 'Connexion',
	p_league_pass_no_access_title: 'Regardez les matchs en direct ou en replay sur n\'importe quel appareil, y compris votre ordinateur, votre smartphone ou votre téléviseur !',
	p_league_pass_no_access_desc: 'Toute l\'action à portée de main : regardez toutes les équipes de la ligue ou votre équipe préférée, choisissez un match à l\'unité, ou découvrez les autres options disponibles.',
	p_league_pass_no_access_note: 'Les conditions générales s\'appliquent',
	category_title: 'Vidéo',
	p_video_playlist_title: 'Liste de lecture :',
	p_no_access_league_pass_title: 'Débloquez le NBA League Pass pour regarder :',
	p_no_access_league_pass_desc: 'Toute l\'action à portée de main : regardez toutes les équipes de la ligue ou votre équipe préférée, choisissez un match unique, ou découvrez les autres options disponibles.',
	p_no_access_league_pass_terms: 'Les conditions générales s\'appliquent',
	p_no_access_league_pass_geo_desc: 'D\'après votre position actuelle, vous n\'êtes pas en mesure de regarder ce match via le NBA League Pass et NBA TV. Pour les abonnés au NBA League Pass, une archive du match sera disponible 3 jours après sa diffusion. Veuillez consulter les horaires des diffuseurs TV et radio locaux, pour profiter des retransmissions locales dans votre région.',
	p_no_access_league_pass_not_found_desc: 'Désolé. La vidéo demandée est introuvable.',
	p_no_access_event_not_found_desc: 'Désolé. L\'événement demandé est introuvable.',
	p_no_access_nba_tv_title: 'Débloquez NBA TV pour regarder :',
	p_no_access_nba_tv_desc: 'Regardez des matchs en direct, des émissions et des matchs classiques à la demande.',
	p_no_access_nba_tv_terms: 'Les conditions générales s\'appliquent',
	p_no_access_nba_tv_geo_desc: 'D\'après votre position actuelle, vous n\'êtes pas en mesure de regarder ce match via le NBA League Pass et NBA TV. Pour les abonnés au NBA League Pass, une archive du match sera disponible 3 jours après sa diffusion. Veuillez consulter les horaires des diffuseurs TV et radio locaux, pour profiter des retransmissions locales dans votre région.',
	p_no_access_nba_tv_not_found_desc: 'Désolé. La chaîne demandée est introuvable.',
	p_no_access_up_next: 'Prochaine diffusion :',
	p_video_completed_title: 'Playlist terminée',
	p_video_completed_desc: 'Revenez au navigateur ou consultez la prochaine playlist concoctée pour vous',
	p_video_share_to: 'Partager à :',
	p_video_more_to_watch: 'Plus encore :',
	p_event_section_title: 'ÉVÉNEMENT',
	p_event_playlist_title: 'Liste de lecture :',
	p_event_button_watch: 'Regarder',
	p_event_button_listen: 'Écouter',
	p_event_button_ticket: 'Billet',
	notfound: 'Désolé. La page demandée est introuvable.',
	notfound_desc: 'Vérifiez l\'URL.<br/> Vous pouvez également utiliser  l\'outil de navigation ou de recherche du site pour trouver le contenu souhaité.',
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'Votre compte NBA League Pass a atteint le niveau maximal de diffusion. Cliquez sur « Continuer » pour reprendre le visionnement sur cet appareil.',
	modal_pcm_custom: 'Continuer',
	modal_pcm_close: 'Annuler',
	modal_adobe_concurrency_header_title: 'Connexion vidéo perdue',
	modal_adobe_concurrency_body_title: '',
	modal_adobe_concurrency_body_description: 'Votre flux a été fermé. Il est possible que la limite maximale de flux simultanés ait été atteinte, que vous ayez subi une perte de réseau ou que vous ayez rencontré une erreur technique. Merci de vous reconnecter et de choisir une chaîne pour continuer.',
	modal_adobe_concurrency_close: 'Terminé',
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'Cette vidéo ne peut être visionnée sur votre appareil. Cliquez sur <a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>ICI</a> pour obtenir de l\'assistance.',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'OK',
	freesample_notice_time: 'Temps restant',
	freesample_notice_title: 'Profitez de vos {0} minutes d’accès',
	freesample_notice_desc: 'Abonnez-vous à une offre complète du League Pass pour continuer à profiter des contenus NBA à la fin de vos {0} minutes.',
	freesample_notice_subscribe_button: 'S\'abonner',
	freesample_notice_cancel_button: 'SANS ENGAGEMENT',
	freesample_popup_title: 'VOTRE TEMPS D\'ACCÈS EST ÉPUISÉ',
	freesample_popup_subtitle: 'Abonnez-vous au League Pass pour accéder à bien plus de contenus fascinants de la NBA.',
	freesample_popup_link: 'En savoir plus',
	freesample_popup_get_minutes_button: 'OBTENIR {0}  MINUTES',
	reg_required_desc: 'Vous devez vous connecter pour voir ce contenu',
	favorite_teams_title: 'Équipes préf.',
	bookmarked_title: 'Enregistré',
	watch_history_title: 'Continuer à regarder',
	game_schedule_title: 'Calendrier des matchs',
	recommended_title: 'Conseillé',
	season_text: 'Saison',
	section_tv_provider_title: 'Mon fournisseur TV',
	section_tv_provider_desc: 'Accédez aux matchs et aux flux en direct de votre fournisseur TV.',
	section_tv_provider_faq: 'FAQ du fournisseur TV',
	section_tv_provider_sign_out: 'Se déconnecter',
	header_menu_account_my_account: 'Mon compte',
	header_menu_account_manage_account: 'Gérer mon compte',
	header_menu_account_favorite_teams: 'Équipes préférées',
	header_menu_account_favorite_players: 'Joueurs préférés',
	header_menu_account_viewing_history: 'Historique de visionnage',
};
